import React, { Fragment } from 'react';

export default () => (
    <div className="circle-wrapper">
        <div className="circle_1 circle"></div>
        <div className="circle_2 circle"></div>
        <div className="circle_3 circle"></div>
        <div className="circle_4 circle"></div>
        <div className="circle_5 circle"></div>
        <div className="circle_6 circle"></div>
        <div className="circle_7 circle"></div>
        <div className="circle_8 circle"></div>
    </div>
);